import { CubePresenter, FlipIntent, Logger } from 'src/3rds/cube'

import { MainPresenter } from 'src/main/Main.presenter'

import UserProfileKeys from './up_keys'
import { UserProfileScope } from './up_scopes'
import { UserProfileService } from './up_service'

const LOG = Logger.get('UserProfilePresenter')
const userProfileService = UserProfileService.singleton()

export class UserProfilePresenter extends CubePresenter<MainPresenter, UserProfileScope> {
    // :: Fields

    // :: Constructor

    public constructor(app: MainPresenter) {
        super(app, new UserProfileScope())
    }

    // :: Methods

    public override release() {
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(
        intent: FlipIntent,
        initialization: boolean,
        last: boolean
    ): Promise<boolean> {
        const keys = new UserProfileKeys(this.app, intent)

        keys.parentSlot(this.scope)

        if (initialization) {
            await this.#initialize()
        }

        if (last) {
            keys.dialogSlot(undefined)
        }

        return keys.allow
    }

    public override publishParameters(intent: FlipIntent): void {
        const keys = new UserProfileKeys(this.app, intent)
        LOG.debug('publishParameters: TODO', keys)
    }

    async #initialize() {
        LOG.debug('initialized', userProfileService)

    }
}

export default UserProfilePresenter
